import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'waiting',
    'failure',
    'button',
    'loadingLabel',
    'readyLabel',
    'explanationsTitle',
    'explanationsBody',
    'readyTitle',
    'readyBody',
  ]

  static values = {
    timeout: { type: Number, default: 180000 },
  }

  connect() {
    if (!this.hasWaitingTarget) return

    this.timer = setTimeout(() => this.#reportTimeout(), this.timeoutValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  contractReady() {
    clearTimeout(this.timer)

    if (!this.hasButtonTarget) return

    this.buttonTarget.disabled = false
    this.loadingLabelTarget.classList.add('d-none')
    this.readyLabelTarget.classList.remove('d-none')
    this.explanationsTitleTarget.classList.add('d-none')
    this.explanationsBodyTarget.classList.add('d-none')
    this.readyTitleTarget.classList.remove('d-none')
    this.readyBodyTarget.classList.remove('d-none')
  }

  #reportTimeout() {
    this.waitingTarget.classList.add('d-none')
    this.failureTarget.classList.remove('d-none')
    this.dispatch('timeout')
  }
}
